import {AdminGenRouteUrls, AdminKeys, AdminModuleCtgs, AdminModules} from "../config/AdminConfig";
import {
    checkNull,
    checkNullArr,
    checkNullJson,
    checkNullStr,
    getJsonValue,
    getDefStr,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    trim
} from "../../common/fusion-ui/utils/ReactUtils";
import React from "react";
import {printError} from "../../common/CommonUtils";
import {BaseReqUrl} from "../../common/CommonConfig";
import axios from "axios";

const TAG = "AdminUtils";

export function isCurrUrlOfAuthRoute(location, currPageUrl, includeLogin = true, additionalRoutes = []) {
    try {
        if (!checkNullStr(currPageUrl)) currPageUrl = (getJsonValue(location, 'pathname') + '').toLowerCase();
        let authRoutes = [AdminGenRouteUrls.forgotPw];
        if (isBoolTrue(includeLogin)) {
            authRoutes.push(AdminGenRouteUrls.login);
        }
        if (checkNullArr(additionalRoutes)) {
            authRoutes.push(...additionalRoutes);
        }
        // return authRoutes.includes(currPageUrl);
        return authRoutes.some(url => (currPageUrl + '').toLowerCase().includes((url + '').toLowerCase()));
    } catch (error) {
        console.error('isCurrUrlOfAuthRoute.error:', error);
        return false;
    }
}

/**
 * Clear session-data & token-id from local-Storage.
 */
export function clearAdminSessionData(lastUrl, removeLastUrl = false) {
    try {
        localStorage.removeItem(AdminKeys.lsSessionSuperKey);
        if (isBoolTrue(removeLastUrl)) {
            clearRememberLastUrl();
        } else {
            storeRememberLastUrl(lastUrl);
        }
    } catch (error) {
        console.error('clearAdminSessionData.error:', error);
    }
}

export function getRememberLastUrl(defUrl = '') {
    const lastUrl = getDefStr(localStorage.getItem(AdminKeys.lastUrlToRemember), defUrl);
    // const lastUrl = getDefStr(unscrambleData(localStorage.getItem(AdminKeys.lastUrlToRemember)), defUrl);
    return isCurrUrlOfAuthRoute(null, lastUrl) ? defUrl : lastUrl;
}

export function storeRememberLastUrl(url = window.location.href) {
    if (checkNullStr(url) && !isCurrUrlOfAuthRoute(null, url)) {
        localStorage.setItem(AdminKeys.lastUrlToRemember, url);
        // localStorage.setItem(AdminKeys.lastUrlToRemember, scrambleData(url));
    }
}

export function clearRememberLastUrl() {
    localStorage.removeItem(AdminKeys.lastUrlToRemember);
}

/**
 * Get session token-id from local-Storage.
 */
export function getAdminSessionToken() {
    return getAdminSessionField(AdminKeys.sessionToken, null);
}

/**
 * Get a specified admin-data key like role-id or created-by etc. from local-Storage.
 */
export function getAdminSessionField(fieldKey, defValue) {
    return checkNullArr(fieldKey) ? getJsonValueFromNestedKeys(getAdminSessionData(), fieldKey, defValue) : getJsonValue(getAdminSessionData(), fieldKey, defValue);
}

/**
 * Get session-data
 */
export function getAdminSessionData() {
    try {
        return getJsonValue(JSON.parse(localStorage.getItem(AdminKeys.lsSessionSuperKey)), AdminKeys.sessionData, {});
        // return getJsonValue(JSON.parse(unscrambleData(localStorage.getItem(AdminKeys.lsSessionSuperKey))), AdminKeys.sessionData, {});
    } catch (e) {
        printError(TAG, 'getAdminSessionData.e:', e);
        return {};
    }
}

export function getCategorizedModules() {
    return {
        [AdminModuleCtgs.MasterMgmt]: [AdminModules.ParentCompany, AdminModules.Company, AdminModules.Members, AdminModules.Users, AdminModules.UserRoles, AdminModules.Groups, AdminModules.Country, AdminModules.State, AdminModules.City, AdminModules.Reports, AdminModules.ModuleAllocation, AdminModules.LoginBypassManager],
        // [AdminModuleCtgs.MasterMgmt]: [AdminModules.ParentCompany, AdminModules.Company, AdminModules.Members, AdminModules.Groups, AdminModules.Country, AdminModules.State, AdminModules.City],
        // [AdminModuleCtgs.UserMgmt]: [AdminModules.Users, AdminModules.UserRoles, AdminModules.Reports],
        [AdminModuleCtgs.ActivityMgmt]: [AdminModules.Wm, AdminModules.Survey, AdminModules.Forum, AdminModules.Meeting],
        [AdminModuleCtgs.ResourceMgmt]: [AdminModules.Pub, AdminModules.Doc, AdminModules.Articles, AdminModules.CS, AdminModules.Videos, AdminModules.Images, AdminModules.Links, AdminModules.News, AdminModules.ExpertSpeaks],
        [AdminModuleCtgs.DatabaseMgmt]: [AdminModules.BackupDb, AdminModules.QueryWindow, AdminModules.DbMaintenance]
    };
}

export function getModuleCategory(moduleName) {
    const allModules = getCategorizedModules();
    if (allModules[AdminModuleCtgs.MasterMgmt].includes(moduleName)) {
        return AdminModuleCtgs.MasterMgmt;
        // } else if (allModules[AdminModuleCtgs.UserMgmt].includes(moduleName)) {
        //     return AdminModuleCtgs.UserMgmt;
    } else if (allModules[AdminModuleCtgs.ActivityMgmt].includes(moduleName)) {
        return AdminModuleCtgs.ActivityMgmt;
    } else if (allModules[AdminModuleCtgs.ResourceMgmt].includes(moduleName)) {
        return AdminModuleCtgs.ResourceMgmt;
    } else if (allModules[AdminModuleCtgs.DatabaseMgmt].includes(moduleName)) {
        return AdminModuleCtgs.DatabaseMgmt;
    } else {
        return null
    }
}

export async function sendAdminRequest({
                                           reqUrl,
                                           reqOptions = {},
                                           redirectOnSessionExpire = true,
                                           timeout = 5000,
                                           type = 'post',
                                           setState,
                                           nestedKeys = [],
                                           tag = TAG,
                                           onFetchBegin,
                                           onFetched,
                                           onError,
                                           fun = 'sendAdminRequest:'
                                       }) {
    return new Promise((resolve, reject) => {
        if (checkNull(onFetchBegin)) onFetchBegin();
        const AXIOS_CONFIG_DATA = {
            baseURL: BaseReqUrl,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                'Authorization': getAdminSessionToken(),
            },
        };
        const REQ_OPTIONS = {
            ...checkNullJson(reqOptions) ? reqOptions : {},
            ...(trim(type).toLowerCase() == 'get') ? AXIOS_CONFIG_DATA : {}
        };

        return axios[type](reqUrl, REQ_OPTIONS, AXIOS_CONFIG_DATA)
            .then(async (res) => {
                const fetchedData = await res.data;
                // console.log(TAG, 'fetchedData:', fetchedData);
                //check if login is already expired or not
                if (isBoolTrue(redirectOnSessionExpire) && isJsonValueTrue(fetchedData, AdminKeys.loginExpired)) {
                    // return resolve(false);
                }
                const data = getJsonValueFromNestedKeys(fetchedData, nestedKeys, fetchedData);
                if (setState) setState(data);
                if (checkNull(onFetched)) onFetched(fetchedData);
                return resolve(data);
            })
            .catch((err) => {
                printError(fun, tag, err);
                if (checkNull(onError)) onError(err);
                return reject(err);
            })
    });
}
